import { render, staticRenderFns } from "./ExpertTagIndex.vue?vue&type=template&id=fe31b9fc&scoped=true"
import script from "./ExpertTagIndex.vue?vue&type=script&lang=js"
export * from "./ExpertTagIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe31b9fc",
  null
  
)

export default component.exports